<template>
    <form class="form__item a-modal__separator">
        <div class="form__item">
            <el-switch :inactive-text="$lang('admin.addPartner.domain.db.title')" class="switch switch--small switch--label" v-model="form.enabled"></el-switch>
        </div>
        <div class="form__item" v-if="form.enabled">
            <div class="form__item form__item--inline">
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.db.host') }}</span>
                    <el-popover v-model="errors.form.host.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.form.host.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.form.host.isErrorPaint }"
                                  :readonly="form.connected"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.db.host.placeholder')" class="input input--big"
                                  v-model="form.host"></el-input>
                    </el-popover>
                </label>
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.db.port') }}</span>
                    <el-popover v-model="errors.form.port.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.form.port.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.form.port.isErrorPaint }"
                                  :readonly="form.connected"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.db.port.placeholder')" class="input input--big"
                                  v-model="form.port"></el-input>
                    </el-popover>
                </label>
            </div>
            <div class="form__item form__item--inline">
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.db.user') }}</span>
                    <el-popover v-model="errors.form.user.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.form.user.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.form.user.isErrorPaint }"
                                  :readonly="form.connected"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.db.user.placeholder')" class="input input--big"
                                  v-model="form.user"></el-input>
                    </el-popover>
                </label>
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.db.pass') }}</span>
                    <el-popover v-model="errors.form.password.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.form.password.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.form.password.isErrorPaint }"
                                  :showPassword="true" @focus="clearErrors"
                                  :readonly="form.connected"
                                  :placeholder="$lang('admin.addPartner.domain.db.pass.placeholder')" class="input input--big"
                                  v-model="form.password"></el-input>
                    </el-popover>
                </label>
            </div>
            <div class="form__item form__item--inline">
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.db.database') }}</span>
                    <el-popover v-model="errors.form.db.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.form.db.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.form.db.isErrorPaint }"
                                  :readonly="form.connected"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.db.database.placeholder')" class="input input--big"
                                  v-model="form.db"></el-input>
                    </el-popover>
                </label>
            </div>
            <div class="form__item form__item--small-margin">
                <button v-if="form.connected" class="btn btn--small btn--main-bg" @click.prevent="disconnectMethod">
                    {{ $lang('admin.addPartner.domain.db.disconnect') }}
                </button>

                <button v-else class="btn btn--small btn--main-bg" @click.prevent="connectMethod">
                    {{ $lang('admin.addPartner.domain.db.connect') }}
                </button>

            </div>

            <div class="form__item">

                <button v-if="form.connected && !form.exported" class="btn btn--small btn--main-bg" @click.prevent="exportMethod">
                    {{ $lang('admin.addPartner.domain.db.export') }}
                </button>

                <div v-else-if="form.connected">{{ $lang('admin.addPartner.domain.db.exported') }}</div>

            </div>
        </div>
    </form>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";
import mixin from "../../mixins/errors";
import helper from "../../mixins/helper";
import Vue from "vue";

export default {
    name: 'RemoteDB',
    mixins: [mixin, helper],
    props: ['partnerId'],
    data() {
        return {
            errors: {
                form: {
                    host: {isError: false, message: ''},
                    port: {isError: false, message: ''},
                    user: {isError: false, message: ''},
                    password: {isError: false, message: ''},
                    db: {isError: false, message: ''}
                }
            },
        }
    },
    mounted() {
        this.$on('reset-form', () => {
           this.resetForm();
        });
    },
    computed: {
        ...mapState('remoteDb', {
            storeForm: state => state.form
        }),
        form: {
            get() {
                return this.storeForm;
            },
            set(val) {
                this.setForm(val);
            }
        }
    },
    watch: {
        partnerId() {
            if (this.partnerId) {
                this.resetForm();

                this.getConnection(this.partnerId)
                    .then((response) => {
                        if(response.data) {
                            this.form = response.data;
                        }
                    })
            }
        },
        'form.enabled': {
            handler: function (val) {
                if (!val) {
                    this.disconnectMethod();
                }
            }
        }
    },
    methods: {
        ...mapActions('remoteDb', [
            'getConnection',
            'connect',
            'disconnect',
            'export',
            'resetForm'
        ]),
        ...mapMutations('remoteDb', [
           'setForm'
        ]),
        connectMethod() {
            this.form.connected = true;

            this.$loading(this.$optionsLoading);

            this.connect({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.$appNotify.success(Vue.prototype.$lang('admin.addPartner.domain.db.connected'));
                })
                .catch((error) => {
                    this.form.connected = false;

                    this.$appNotify.error(Vue.prototype.$lang('admin.addPartner.domain.db.checkConnection'));

                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        disconnectMethod() {
            this.form.connected = false;
            this.form.exported = false;

            this.$loading(this.$optionsLoading);

            this.disconnect({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.$appNotify.success(Vue.prototype.$lang('admin.addPartner.domain.db.disconnected'));
                })
                .catch((error) => {
                    this.form.connected = true;
                    this.form.exported = true;

                    // this.$appNotify.error('Ошибка');
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        exportMethod() {
            this.form.exported = true;

            this.$loading(this.$optionsLoading);

            this.export({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.$appNotify.success(Vue.prototype.$lang('admin.addPartner.domain.db.exported2'));
                })
                .catch((error) => {
                    this.form.exported = false;

                    this.$appNotify.error(Vue.prototype.$lang('admin.addPartner.domain.db.exportError'));
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        }
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader--img .el-upload {
    border: none !important;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
</style>
